export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    setTimeout(() => {
      const element = document.querySelector(location.hash);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 750);
  }
};
